module.exports = __webpack_public_path__ + "img/placeholder_girl_2x.5aa83c50.png";